import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {Link} from "react-router-dom"

class ColName extends Component {
    render() {
        const {item} = this.props
        const {_id, name, code} = item

        return <td className='PartnerName'>
            {/* <Link className="d-block" to={`partners/${_id}`}>{name}</Link> */}
            <span className="d-block text-primary">{name}</span>
            <div className="text-secondary"><small>{code}</small></div>
        </td>
    }
}

ColName.propTypes = {
    item: PropTypes.object.isRequired
}

export default ColName